import React, { useState, useRef, useEffect } from 'react';
import { BsGearFill } from 'react-icons/bs';
import './columnToggle.scss';

const ColumnToggle = ({ columns, visibleKeys, onChange, footer }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, []);

    const toggle = (key) => {
        const next = visibleKeys.includes(key)
            ? visibleKeys.filter(k => k !== key)
            : [...visibleKeys, key];
        onChange(next);
    };

    return (
        <div className="col-toggle" ref={ref}>
            <button
                className="col-toggle__btn"
                onClick={() => setOpen(prev => !prev)}
                title="Toggle columns"
                type="button"
            >
                <BsGearFill size={14} />
            </button>
            {open && (
                <div className="col-toggle__dropdown">
                    <div className="col-toggle__title">Columns</div>
                    <div className="col-toggle__list">
                        {columns.map(col => (
                            <label key={col.key} className="col-toggle__item">
                                <input
                                    type="checkbox"
                                    checked={visibleKeys.includes(col.key)}
                                    onChange={() => toggle(col.key)}
                                />
                                <span>{col.label}</span>
                            </label>
                        ))}
                    </div>
                    {footer && (
                        <div className="col-toggle__footer">
                            {footer}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ColumnToggle;
